export default __webpack_public_path__ + "static/media/user-role.4c9aefa3.svg";